import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import CrossfadeImage from 'react-crossfade-image';
import intl from 'react-intl-universal';

import './LayerToggle.css';

@inject("appStore")
@observer
class LayerToggle extends Component {
    returnLayerImage(url) {
        let layerURL = url;
        layerURL = layerURL.replace("{z}", `${this.props.appStore.appConfig.map.viewport.center.lng}`);
        layerURL = layerURL.replace("{x}", `${this.props.appStore.appConfig.map.viewport.center.lat}`);
        layerURL = layerURL.replace("{y}", `${this.props.appStore.appConfig.map.viewport.zoom}`);
        return layerURL;
    };

    getTitle = function (inactiveMapMode) {
        if(inactiveMapMode === "roadmap"){
            return intl.get("MapContainer.roadmap");
        } else if (inactiveMapMode === "satellite"){
            return intl.get("MapContainer.satellite");
        } else if (inactiveMapMode === "custom"){
            return this.props.appStore.appConfig.map.baseLayers["custom"].title
        }
    };

    render() {
        return (
            <div className={"LayerToggle " + this.props.appStore.inactiveMapMode}
                 onClick={() => {
                     this.props.appStore.toggleMapMode();
                 }
                 }>
                <span>{this.getTitle(this.props.appStore.inactiveMapMode)}</span>
                <CrossfadeImage className={'InnerLayerToggle'}
                                src={this.returnLayerImage(this.props.appStore.appConfig.map.baseLayers[this.props.appStore.inactiveMapMode].static)}
                                alt={this.props.appStore.inactiveMapMode}
                                delay={500}
                                duration={300}
                                timingFunction={"ease"}
                />
            </div>
        );
    }
}

export default LayerToggle;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/LayerToggle/index.js